import React from 'react';
import { motion } from 'framer-motion';
import { Code2Icon, TrendingUpIcon, MousePointerClickIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <Code2Icon className="w-10 h-10 text-teal" data-id="element-199" />,
    title: 'Ecommerce Development',
    description: 'We build high-performance online stores on WooCommerce, Shopify, and custom platforms. Mobile-first design, fast load times, seamless checkout. We also handle complex platform migrations — including subscription systems — with zero downtime and 100% data integrity.',
    tags: ['WooCommerce', 'Shopify', 'WordPress', 'Custom PHP', 'React']
  }, {
    icon: <TrendingUpIcon className="w-10 h-10 text-teal" data-id="element-200" />,
    title: 'SEO & Digital Marketing',
    description: 'We drive qualified traffic to your store through technical SEO, content strategy, social media management, and paid advertising. Our SEO work has delivered 3x traffic growth and 100+ first-page Google rankings for fashion brands.',
    tags: ['SEO', 'Meta Ads', 'Google Ads', 'TikTok', 'Email Marketing', 'Content Strategy']
  }, {
    icon: <MousePointerClickIcon className="w-10 h-10 text-teal" data-id="element-201" />,
    title: 'Conversion Rate Optimization',
    description: "We don't just build stores — we grow them. A/B testing, analytics setup, checkout optimization, page speed improvements, and CTR optimization. Our clients see 30-50% improvements in key conversion metrics within 6 months.",
    tags: ['Google Analytics', 'A/B Testing', 'Schema Markup', 'Speed Optimization', 'Meta Pixel']
  }];
  return <section id="services" className="py-24 bg-gray-50" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-204">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold font-heading text-navy mb-4" data-id="element-205">
            What We Do
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-206">
            Everything your ecommerce brand needs to sell more online — under
            one roof.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-207">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-208">
              <div className="absolute top-0 right-0 w-32 h-32 bg-teal/5 rounded-bl-full -z-10 group-hover:bg-teal/10 transition-colors" data-id="element-209"></div>

              <div className="mb-6 bg-gray-50 w-16 h-16 rounded-xl flex items-center justify-center border border-gray-100" data-id="element-210">
                {service.icon}
              </div>

              <h3 className="text-xl font-bold font-heading text-navy mb-4" data-id="element-211">
                {service.title}
              </h3>

              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-212">
                {service.description}
              </p>

              <div className="mt-auto" data-id="element-213">
                <div className="flex flex-wrap gap-2" data-id="element-214">
                  {service.tags.map((tag, i) => <span key={i} className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-gray-50 text-gray-600 border border-gray-100" data-id="element-215">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}